import styled from 'styled-components';
import { ClickToCopyCode } from 'ui/clickToCopy';
import { FormField } from 'ui/formField';
import { Body2, colors, fontSizes, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const SaveCredentialsFormField = styled(FormField)`
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  padding-top: ${spacing.plusHalf};

  p {
    font-size: ${fontSizes.s14} !important;
    line-height: ${fontSizes.s20};
  }
`;

export const StyledClickToCopy = styled(ClickToCopyCode)`
  padding: ${spacing.half} ${spacing.threeQuarter} !important;
`;

export const InputWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: ${spacing.half};

  [data-test='tooltip-trigger'] {
    width: fit-content;
  }
`;

export const SecondaryBody2 = styled(Body2)`
  color: ${colors.textSecondary};
  margin-left: ${spacing.quarter};
`;

export const ServerKeyContent = styled.div`
  max-width: ${pxToRem(140)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
